export default "__VITE_ASSET__cb0b5101__"